import SiafLiteApiRepository from "../../external/siafLiteApi";

class ConfiguracaoPesquisaSatisfacaoService {
  constructor() {
    this.urlBase = "/faturamento/configuracoes-pesquisa-satisfacao";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }
}

export default ConfiguracaoPesquisaSatisfacaoService;
